import classes from "./LoginLayout.module.scss";
import logo from "../assets/logo-icon.svg";

export default function Login({ children }) {
  return (
    <div justify="center" align="middle" className={classes.container}>
      <div className={classes.banner}>
        <div>
          <h1>Welcome to COP29 Master Delivery Schedule System</h1>
          <img className={classes.logo} src={logo} alt="logo" />
        </div>
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  );
}
